import { TextBox } from '@hivediversity/common-lib/inputs';
import { Form } from 'formik';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: flex-start;
  padding-bottom: 20px;
  flex-direction: column;
  color: white;
  width: 100%;
  padding-left: 80px;
  padding-right: 32px;
  background: ${({ background }) => background || '#000'};
  overflow-x: auto;
  flex: 1;
  @media screen and (max-width: 767px) {
    padding: 0 20px;
  }
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
  width: 100%;
`;

export const Title = styled.div`
  font-family: 'Brandon Grotesque', Arial, sans-serif;
  color: white;
  font-weight: 700;
  font-size: 40px;
  margin-bottom: 20px;
  @media screen and (max-width: 420px) {
    font-size: 30px;
  }
  span {
    margin: 0 10px;
    text-transform: capitalize;
  }
`;

export const StyledTextBox = styled(TextBox)`
  margin-bottom: 10px;
  border: 0;
  border-bottom: 1px solid #fff;
  text-align: center;
  font-weight: 700;
  font-size: 22px;
  @media screen and (max-width: 420px) {
    font-size: 16px;
  }
  &:hover,
  &:focus {
    color: #fff;
    border: none;
    background: transparent;
    border-bottom: 1px solid #fff;
    box-shadow: none;
  }
  ::placeholder {
    font-size: 22px;
    font-weight: 700;
    @media screen and (max-width: 420px) {
      font-size: 16px;
    }
  }
`;

export const ErrorMessage = styled.p`
  color: #fc0b03;
  font-size: 18px;
`;

export const StyledForm = styled(Form)`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 450px;
  > div {
    margin-bottom: 25px;
  }
`;

export const WrapperButton = styled.div`
  margin-top: 20px;
  @media screen and (max-width: 767px) {
    margin-left: 50px;
  }
`;
